import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CompanyLifecycleRepository } from '@app/domain/ports/tpv/company-lifecycle.repository';
import { UpdateCompanyRequest } from '@app/data/dtos/tpv/company-update.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope } from '@app/data/tpv/tpv-envelope';

/**
 * Implementación HTTP del ciclo de vida de Company/Unit (§3).
 *
 * Auth: NO setea cabeceras manuales. El `authInterceptor` agrega el Bearer y
 * maneja 401/refresh; el `ApiKeyInterceptor` agrega el `x-api-key`. Estos
 * endpoints no requieren `Idempotency-Key`.
 */
@Injectable()
export class CompanyLifecycleRemoteDataSource extends CompanyLifecycleRepository {
  private readonly http = inject(HttpClient);

  override updateCompany(idCompany: string, payload: UpdateCompanyRequest): Observable<void> {
    return this.http
      .patch<TpvEnvelope<unknown>>(tpvUrl(`companies/${idCompany}/`), payload)
      .pipe(map(() => void 0));
  }

  override deleteCompany(idCompany: string): Observable<void> {
    return this.http
      .delete<TpvEnvelope<unknown>>(tpvUrl(`companies/${idCompany}/`))
      .pipe(map(() => void 0));
  }
}
